import { useState } from "react";
import api from "../../utils/axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    if (mobile.length !== 10) return alert("Enter a valid 10-digit mobile number");
    if (!password) return alert("Enter password");

    setLoading(true);
    try {
      const res = await api.post("/auth/login", {
        mobile,
        password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);
      localStorage.setItem("name", res.data.name);

      if (res.data.role === "ADMIN") navigate("/admin/dashboard");
      else if (res.data.role === "VOLUNTEER") navigate("/volunteer/dashboard");
    } catch (err) {
      alert(err.response?.data?.msg || "Invalid login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-rose-50 to-rose-100">
      <div className="bg-white p-8 rounded-3xl shadow-2xl w-80 relative">
        <h2 className="text-2xl font-bold mb-6 text-center text-rose-700">
          IGF Admin Login
        </h2>

        <input
          type="tel"
          className="w-full border border-gray-300 p-3 mb-4 rounded-lg focus:ring-2 focus:ring-rose-400 outline-none"
          placeholder="Mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />

        <div className="relative mb-6">
          <input
            type={showPassword ? "text" : "password"}
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-rose-400 outline-none pr-12"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          className={`w-full bg-rose-600 hover:bg-rose-700 text-white py-3 rounded-xl font-semibold shadow-lg transition duration-300 flex items-center justify-center gap-2 ${
            loading ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {loading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </button>

        <p className="text-sm text-gray-400 mt-4 text-center">
          Forgot your password? Contact admin.
        </p>
      </div>
    </div>
  );
};

export default Login;
